import { getAllEnabledCountries } from "../../../../../utils/utility";
import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function insertData(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    let row = [];
    const rowId = config.tableType;
    config.columns.forEach(column => {
        const columnId = column.id;
        let columnValueData = null;
        const columnValue = config.data.hasOwnProperty(columnId) && config.data[columnId];
        const displayAsIs = column.data.displayInBodyAsIs;
        const columnDataType = column.data.displayInBodyAs;
        const highlightColumn = column.data.highlightBodyText;
        let validColumnValue = true;
        if (columnDataType !== "string") {
            columnValueData = { ...column.data };
            columnValueData.defaultValue = columnValue;

            if (columnValueData.validationRules) {
                columnValueData.valid = validColumnValue;
            }

            const dateSpecificFields = ['dateOfRequest', 'quoteCreationDate', 'quoteValidUntil', 'quoteSubmissionDate', 'acceptanceRejectionDate'];

            if (dateSpecificFields.includes(columnId)) {
                columnValueData.defaultValue = getDateWithSpecificFormat(columnValue);
            }

            if (columnDataType === "select") {
                let options = [];
                if (config.data.hasOwnProperty("dropdownOptions") && config.data.dropdownOptions.hasOwnProperty(columnId)) {
                    options = config.data.dropdownOptions[columnId];
                }
                if (columnId === 'leadCountry') {
                    const leadCountryOptions = [];
                    const listOfCountries = config.data.countriesRequested ? [...new Set(config.data.countriesRequested.split(','))] : [];
                    listOfCountries.map(country => {
                        if (getAllEnabledCountries().includes(country) && country.length >= 2) {
                            leadCountryOptions.push({ id: country, label: country })
                        }
                    });
                    options = leadCountryOptions;
                }
                columnValueData.options = options;
            }
        }

        row.push({
            [columnId]: {
                id: columnId + "|" + rowId,
                columnId: columnId,
                type: columnDataType,
                value: columnValueData || columnValue,
                width: column.width,
                displayAsIs: displayAsIs,
                showInMobileViewAs: column.showInMobileViewAs,
                highlightColumn: highlightColumn,
                clickHandler: columnDataType !== "string" ? event => config.bodyButtonsHandler(event) : null
            }
        });
    });

    tableData.push({
        id: rowId,
        data: row
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}